import { EventType, IncrementalSource } from "rrweb";

/** @note: rrweb-player function; modified 22.01.26 */
export const getInactivePeriods = (
  events,
  inactivePeriodThreshold,
) => {
  const inactivePeriods = [];
  let lastActiveTime = events[0].timestamp;
  for (const event of events) {
    if (!isUserInteraction(event)) continue;
    if (event.timestamp - lastActiveTime > inactivePeriodThreshold) {
      inactivePeriods.push([lastActiveTime, event.timestamp]);
    }
    lastActiveTime = event.timestamp;
  }
  return inactivePeriods;
}

/** @note: rrweb-player function; modified 22.01.26 */
const isUserInteraction = (event) => {
  if (event.type !== EventType.IncrementalSnapshot) {
    return false;
  }
  return (
    event.data.source > IncrementalSource.Mutation &&
    event.data.source <= IncrementalSource.Input
  );
}